import { render } from "./RecipientsList.vue?vue&type=template&id=edf8ad86"
import script from "./RecipientsList.vue?vue&type=script&lang=js"
export * from "./RecipientsList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__